<template>
    <form class="form-horizontal modal_content" @submit.prevent="attach()">
        <h4>{{ $t('members') }}: {{ teamName }}</h4>
        <div class="form-group">
            <div class="col-sm-6 col-md-8 m_sm_bottom_15">
                <pml-select v-model="selected" :options="availableMembers" label="full_name" give-back="id"></pml-select>
            </div>
            <div class="col-sm-6 col-md-4 t_right">
                <button class="btn btn-warning" v-pml-tooltip="$t('refresh')" @click="fetchRecord()"><i class="fa fa-refresh"></i></button>
                <button type="submit" class="btn btn-default waves-light">
                    <span class="btn-label">
                        <i class="fa fa-plus-circle"></i>
                    </span>
                    {{ $t('member') }}
                </button>
                <router-link :to="{ name: 'teams.index' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
            </div>
        </div>
        <div class="over_auto" v-pml-block="isLoading">
            <table class="table table-striped table-bordered m-0 table_border_out">
                <thead>
                    <tr>
                        <th class="asc">{{ $t('name') }}</th>
                        <th class="t_center w_100">{{ $t('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list" :key="item.id">
                        <td>{{ item.full_name }}</td>
                        <td class="t_center">
                            <span class="btn btn-danger btn-xs" v-pml-tooltip="$t('delete')" @click="detach(item.id)"><i class="fa-fw fa fa-times"></i></span>
                        </td>
                    </tr>
                    <tr v-if="list.length < 1">
                        <td class="t_center" colspan="2"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getMembers, attachMember, detachMember } from 'services/teams'
    import { mapGetters, mapActions } from 'vuex'
    import { orderBy } from 'lodash'

    export default {
        name: 'TeamMembers',
        data () {
            return {
                selected: null,
                isLoading: false,
                record: []
            }
        },
        mounted () {
            this.fetchRecord()
        },
        watch: {
            '$route' () {
                this.fetchRecord()
            }
        },
        computed: {
            ...mapGetters({
                members: 'getMembers'
            }),
            availableMembers () {
                return this.record.notMembers || []
            },
            teamName () {
                return this.record.name || ''
            },
            list () {
                return orderBy(this.record.members, ['full_name']) || []
            }
        },
        methods: {
            ...mapActions([ 'teamMembersAmountUpdate' ]),
            fetchRecord () {
                this.isLoading = true

                getMembers(this.$route.params.id)
                    .then(response => { this.record = response.data })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            attach () {
                this.isLoading = true

                attachMember(this.$route.params.id, this.selected)
                    .then(response => {
                        this.record = response.data
                        this.selected = null
                        this.teamMembersAmountUpdate(response.data)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            detach (id) {
                this.isLoading = true

                detachMember(this.$route.params.id, id)
                    .then(response => {
                        this.record = response.data
                        this.teamMembersAmountUpdate(response.data)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/teams/components/members/Main.vue